import { send } from "process";
import { getSerializedPack } from "../Lib";
import { Pack, PackAttachment } from "../Types";
import { WebRTCPeer } from "./Axon/WebRTCPeer";

const peer = new WebRTCPeer();

export const WebRTCTransfer = {
  peer,
  host: async (id: string) => {
    await peer.host(`optimem_${id}`);
  },
  stopHost: async () => {
    await peer.stopHost();
  },
  connect: async (id: string) => {
    await peer.join(`optimem_${id}`);
  },
  send: async (payload: string) => {
    if (peer.status === "connected") {
      peer.send("message", payload, "reliable");
    }
  },
  requestSendPack: async (pack: Pack, serializedPack: Uint8Array) => {
    WebRTCTransfer.send(JSON.stringify({
      type: "pack_request",
      id: pack.metadata.id,
      description: pack.extra.description,
      version: pack.metadata.version,
      contentType: "application/zip",
      url: "local",
      name: pack.metadata.name,
      size: serializedPack.byteLength,
      attribution: pack.extra.attribution,
    }));
  },
  sendPack: async (
    serializedPack: Uint8Array,
    onProgressCallback: (number) => void,
    onCompletionCallback: () => void,
  ) => {
    // 2-4 bytes per number, 16 KB max, 50% buffer
    const MAX_PACKET_SIZE = 16 * 1024;
    const CHUNK_SIZE = Math.floor(MAX_PACKET_SIZE / 32);
    const CHUNK_SIZE_WITH_BUFFER = Math.round(CHUNK_SIZE * 0.75);

    // This may need to be /32 instead of /2
    const maxChars = Math.round(((16 * 1024) / 2) * 0.75); //CHUNK_SIZE_WITH_BUFFER;

    let i = 0;
    for (let j = 0; j < serializedPack.length; j += maxChars) {
      const end = Math.min(j + maxChars, serializedPack.length);
      const chunk = serializedPack.slice(j, end);
      await WebRTCTransfer.send(JSON.stringify({
        type: "pack_chunk",
        index: i,
        count: Math.ceil(serializedPack.length / maxChars),
        content: chunk.toString(),
      }));
      onProgressCallback(i / Math.ceil(serializedPack.length / maxChars));
      // console.log("sending chunk", i, chunk.length);
      i++;
    }
    onCompletionCallback();
  },
  approve: async () => {
    await WebRTCTransfer.send(JSON.stringify({
      type: "pack_approve",
    }));
  },
};
